import React from "react";
import { Link } from "react-router-dom";

// MUI icon
import SendIcon from "@mui/icons-material/Send";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";


import { SuccessNotify, ErrorNotify } from "../../ui/Toast";

//import APIs
import Like from "../../api/customer/design/Like";
import SaveDesign from "../../api/customer/design/SaveDesign";

import DesignSlider from "./DesignSlider";

const DesignCard = (props) => {
  const { design, auth } = props;

  const [isSaved, setSaved] = React.useState(design.isSaved);
  const [isLiked, setLiked] = React.useState(design.isLiked);

  const saveDesign = async () => {
    if (!auth.isAuthenticated) {
      ErrorNotify("برای ذخیره، باید وارد شوید");
      return;
    }
    await SaveDesign(auth.token, design.id);
    if (!isSaved) SuccessNotify("ذخیره با موفقیت انجام شد");
    setSaved(!isSaved);

    return;
  };
  const likeDesign = async () => {
    if (!auth.isAuthenticated) {
      ErrorNotify("برای پسند، باید وارد شوید");
      return;
    }
    await Like(auth.token, design.id);
    setLiked(!isLiked);

    return;
  };
  return (
    <div className="row m-0 p-0 ">
      <div className="col-md-2 d-none d-md-block"></div>
      <div className="col-md-8 col-12 mb-1">
        <div className="row mb-2" dir="ltr">
          <div className="col-2 col-md-3 text-left my-auto mb-1">
            <Avatar
              alt={design.DesignCat1.title}
              src={design.DesignCat1.mediaUrl}
            />
          </div>
          <div className="col-10 col-md-9 text-left my-auto">
            <span>{design.DesignCat1.title}</span>
          </div>
          <DesignSlider medias={design.DesignMedias} />
          <div className="row" style={{ marginTop: "-15px", zIndex: 100 }}>
            <div className="col-1">
              {isSaved ? (
                <BookmarkIcon
                  onClick={() => saveDesign()}
                  className="panel-link pointer"
                />
              ) : (
                <BookmarkBorderIcon
                  onClick={() => saveDesign()}
                  className="panel-link pointer"
                />
              )}
            </div>

            <div className="col-1">
              {isLiked ? (
                <FavoriteIcon
                  onClick={() => likeDesign()}
                  className="panel-link pointer"
                />
              ) : (
                <FavoriteBorderIcon
                  onClick={() => likeDesign()}
                  className="panel-link pointer"
                />
              )}
            </div>
            <div className="col-1">
              <Link to={`/basket/${design.id}`} className="panel-link">
                <ShoppingCartIcon />
              </Link>
            </div>
            <div className="col-9" dir="rtl">
              <SendIcon className="panel-link pointer d-none" />
            </div>
          </div>
        </div>
        <div className="col-12 mb-4">
          <Link to={`/basket/${design.id}`} className="panel-link">
            <Button
              size="small"
              variant="contained"
              color="error"
              fullWidth={true}
              endIcon={<ShoppingCartIcon />}
            >
              انتخاب طرح و ادامه
            </Button>
          </Link>
        </div>
      </div>
      <div className="col-md-2 d-none d-md-block"></div>
    </div>
  );
};

export default DesignCard;
